<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="100"
    >
    
    <FormItem label="分类" prop="classify_id" v-if="classifyIds.length > 1"> 
        <Select v-model="formValidate.classify_id" clearable>
          <Option
            v-for="item in classifyIds"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>
      
      <FormItem label="选择平台" prop="liveIds">
        <Select v-model="formValidate.liveIds" clearable multiple >
          <Option v-for="item in liveIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </FormItem>

      <FormItem label="关键字" prop="keyword">
        <Input v-model="formValidate.keyword" placeholder="请输入关键字"></Input>
      </FormItem>

      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'

export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      classifyIds:[],
      loadding:false,
      video_show:false,
      show_path:'',
      videoSource:'',
      liveIds:[],
      formValidate: {
        id: '',
        classify_id: -1,
        keyword:'',
        liveIds:[]
      },
      ruleValidate: {
        classify_id: [
          {
            required: true,
            message: '分类必须选择',
            trigger: 'change'
          }
        ],liveIds: [
          {
            required: true,
            message: '平台必须选择',
            trigger: 'change',
            type: 'array'
          }
        ], keyword: [
          {
            required: true,
            message: '关键字不能为空',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    setLiveType(live_list) {
      var data = new Array()
      for (var i = 0; i < live_list.length; i++) {
        data[i] = { id: live_list[i].id.toString(), name: live_list[i].name }
      }
      this.liveIds = data
    },
    setClassifyData (classify_list) {
      var data = new Array()
      for (var i = 0; i < classify_list.length; i++) {
        data[i] = { id: classify_list[i].id.toString(), name: classify_list[i].name }
      }
      this.classifyIds = data
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
    
  }
}
</script>
